export default __webpack_public_path__ + "static/media/IMG_8281.49ed139d.jpg";